/** Dari labels for content workflow states (C4D). */
export const CONTENT_STATE_LABELS: Record<string, string> = {
  draft: "پیش‌نویس",
  pending_approval: "در انتظار تأیید",
  scheduled: "زمان‌بندی‌شده",
  published: "منتشرشده",
  expired: "منقضی",
  paused: "متوقف",
  archived: "بایگانی",
};

export const FILTER_ALL = "all";
export const FILTER_QUEUE = "pending_approval";
export const FILTER_PAUSED = "paused";

export type ContentListFilter = typeof FILTER_ALL | typeof FILTER_QUEUE | typeof FILTER_PAUSED | string;

export function formatDiffValue(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "string") return value || "—";
  if (typeof value === "boolean") return value ? "بله" : "خیر";
  if (typeof value === "number") return String(value);
  return JSON.stringify(value);
}
